import React from 'react';

class Toggle extends React.Component {
  buildToggle() {
    return (
      <div className="form-group toggle-group">
        <input
          className="itoggle"
          type="checkbox"
          name={this.props.name}
          id={this.props.id}
          onClick={this.props.onClick}
          checked={this.props.checked}
        />
        <label htmlFor={this.props.id} />
        <span className="toggle-label">{this.props.checked ? this.props.on : this.props.off}</span>
      </div>
    );
  }

  render() {
    return this.buildToggle();
  }
}

export { Toggle };
